// Routes.jsx
import { useRoutes } from 'react-router-dom';
import Home from './pages/Home';

const AppRoutes = () => {
  const routes = useRoutes([
    { path: '/', element: <Home /> },
    // Other routes go here
  ]);

  return routes;
};

export default AppRoutes;
